import dispatch from ".";
import actions from "../actions";

const AuthDispatcher = {
  login: (payload) => login(payload),
  logout: (payload) => logout(payload),
  setSession: (payload) => setSession(payload),
};

const login = (payload) => {
  dispatch(actions.LOG_IN, payload);
};

const logout = (payload) => {
  dispatch(actions.LOG_OUT, payload);
};

const setSession = (payload) => {
  dispatch(actions.SET_SESSION, payload);
};

export default AuthDispatcher;
